import React from 'react';
import theme from '../../theme';

export function Step({ icon: Icon, title, body }) {
  return (
    <div style={{ flex: 1, textAlign: 'center' }}>
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: theme.radii.lg,
          background: theme.colors.surfaceSunken,
          border: `1px solid ${theme.colors.borderDefault}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
        }}
      >
        <Icon style={{ width: 22, height: 22, color: theme.colors.accentPrimary }} />
      </div>
      <h3
        style={{
          fontFamily: theme.typography.fontSans,
          fontWeight: theme.typography.weight.semibold,
          fontSize: theme.typography.size.md,
          margin: '0 0 8px',
        }}
      >
        {title}
      </h3>
      <p
        style={{
          fontFamily: theme.typography.fontSans,
          fontSize: theme.typography.size.sm,
          color: theme.colors.textSecondary,
          lineHeight: theme.typography.leading.normal,
          margin: 0,
          maxWidth: 280,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        {body}
      </p>
    </div>
  );
}